<div class="rewards-header-card-image" *ngIf="headerCardImageUrl" [style.background-image]="headerCardImageUrl"></div>
<span class="rewards-header-card-text">{{ rewardsCard.title | translate }}</span>
